export const fabVariants = {
    hidden: { 
        rotate: -180,
        // background: '#D4F4F6f'
    },
    visible: {
        rotate: 0,
        // background: '#33CCCC',
        transition: { duration: 1.5 }
    }
}

export const filterVariants = {
    hidden: {
        opacity: 0,
        // iconLenght: 0
        // rotate: -360
    },
    visible: {
        opacity: 1,
        // inonLength: 1,
        // rotate: 0,
        transition: {
            duration: 2.5,
            ease: "easeInOut"
        }
    }
}
